import React from 'react';
import './App.css';
import {useRoutes} from "react-router-dom";
import routes from './routes'
import ApiService from "./utils/ApiService";
import {Toast} from "antd-mobile";
import {useGlobalState} from "./utils/GlobalStateContext";

function App() {
  const element = useRoutes(routes)
  const { state, dispatch } = useGlobalState();
  React.useEffect(()=>{
    console.log('state',state)
    if(state.init){
      getConfig();
    }
    //React.Component.prototype.$systemConfig={};
  },[])
  const getConfig = async () => {
    const ret = await ApiService.getConfig();
    if (ret && ret.code == 1) {
      //global.systemConfig = {...global.systemConfig,...ret.data};
      dispatch({ type: 'SET_GLOBAL_VARIABLE', payload:  {...state,...ret.data} });
      console.log('获取状态结果',state.project_name)
    } else if (ret) {
      Toast.show(ret.message)
    }
  }
  return (
    <>
      {element}
    </>
  );
}

export default App;
